export default {
  id: null,
  contact: {
    city: null,
    name: null,
    region: null,
    address: null,
    country: null,
    emails: [],
    phone_numbers: []
  },
  financial: {
    cui: null,
    bank: {
      iban: null,
      name: null,
      currency: null
    },
    reg_com: null
  }
}